import { render, staticRenderFns } from "./ConnectionSelect.vue?vue&type=template&id=040b518a&scoped=true&"
import script from "./ConnectionSelect.vue?vue&type=script&lang=js&"
export * from "./ConnectionSelect.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionSelect.vue?vue&type=style&index=0&id=040b518a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040b518a",
  null
  
)

export default component.exports